export default "__VITE_ASSET__CpoCyeBh__"